import { render } from "./Dropdown.vue?vue&type=template&id=5a5b3335"
import script from "./Dropdown.vue?vue&type=script&lang=js"
export * from "./Dropdown.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__